export class SubContractorsWiseEmployeesDto {
    subContractorsData: string[];
    employeesData: number[];
    attendanceData: number[];
}